import React from "react";
import { ChangedTextActivityCard } from "./ChangedTextActivityCard";
import { useTranslations } from "@adsk/acc-issues-translations";
import { activityVerbs } from "@adsk/acc-issues-types";
import { ActivityText } from "@adsk/alloy-react-activity-log";
import { activityTextDefaultStyle } from "./activityTextDefaultStyle";
import { PlacementActivityCardProps } from "@adsk/acc-issues-types";
import { usePlacementDataForActivityPlacement } from "../../IssueDetailTabPanel/hooks/PlacementFieldHooks/usePlacementData";

export const PlacementActivityCard = ({
  commonActivityProps,
  placement,
  verb,
}: PlacementActivityCardProps) => {
  const { T } = useTranslations();
  const { placementText: text } = usePlacementDataForActivityPlacement({
    placement,
  });
  let action;
  switch (verb) {
    case activityVerbs.ISSUE_PLACEMENT_ADD:
      action = "added";
      break;
    case activityVerbs.ISSUE_PLACEMENT_REMOVE:
      action = "removed";
      break;
    case activityVerbs.ISSUE_PLACEMENT_REPOSITION:
      action = "repositioned";
      break;
    default:
      action = "";
  }
  const { isAggregated } = commonActivityProps;
  if (isAggregated) {
    return <ActivityText text={text} style={activityTextDefaultStyle} />;
  }
  return (
    <ChangedTextActivityCard
      {...commonActivityProps}
      title={T.translate(
        `activityLog.titles.issuePlacement.${placement.surfaceType}.${action}`
      )}
      text={text}
      data-testid="placement-activity-card"
    />
  );
};
